import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "./apiRoutes";

interface UseGetPlanByIdProps {
  projectId: string;
  planId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPlanById = async (planId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/plans/${planId}`);

const useGetPlanById = ({
  planId,
  projectId,
  queryParams,
}: UseGetPlanByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["plan", planId],
    queryFn: () => getPlanById(planId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPlanById;
